import React from 'react';
import Header from '../components/Header';
import Partners from '../components/Partners';
import Footer from '../components/Footer';

function PartnersPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <Partners />
      </div>
      <Footer />
    </>
  );
}

export default PartnersPage;
